import Ajax from 'global/od/Ajax';

export const searchSku = (data = {}) =>
	Ajax({
		url: '/ajax/quickorder/skusearch',
		method: 'POST',
		dataType: 'html',
		data,
	});

export const updateQuantity = (data = {}) =>
	Ajax({
		url: '/ajax/quickorder/skusearch',
		method: 'POST',
		dataType: 'html',
		data,
	});

export const deleteProduct = (data = {}) =>
	Ajax({
		url: '/ajax/quickorder/delete',
		method: 'POST',
		dataType: 'html',
		data,
	});
